export enum ActionComponent {
  CombinedSocialAndEmail = "combined-social-and-email",
  EmailForm = "email-form",
  OverlaySignUpButton = "overlay-sign-up-button",
  SignUpButton = "sign-up-button",
  SocialButtons = "social-buttons",
}
